import { runtimeEnv } from 'config/runtimeEnv';
import requestInstance from './Request';
import { setCurrentUser } from '../utils/utils';
import { API_ENDPOINT } from './Api';

let env = runtimeEnv('B2B_API_BASE_URL');

export const rideDetailsApi = async (data) => {
  const url = `${env}${API_ENDPOINT.Dashboard.rideDetailsApi + '?location=' + (data?.location ? data?.location : '') + '&isB2B=true' + '&dateFrom=' + data?.dateFrom + '&dateTo=' + data?.dateTo}`;

  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};

export const totalRegistrationApi = async (data) => {
  const url = `${env}${API_ENDPOINT.Dashboard.registrationApi + '?location=' + (data?.location ? data?.location : '') + '&isB2B=true' + '&dateFrom=' + data?.dateFrom + '&dateTo=' + data?.dateTo}`;
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};

export const rideAnalyticApi = async (data) => {
  const url = `${env}${API_ENDPOINT.Dashboard.rideAnalyticApi + '?location=' + (data?.location ? data?.location : '') + '&isB2B=true' + '&dateFrom=' + data?.dateFrom + '&dateTo=' + data?.dateTo}`;
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};

export const topCompaniesApi = async (data) => {
  let url = '';
  if (data?.companyId) {
    url = `${env}${API_ENDPOINT.Dashboard.topCompanies + '?companyId=' + data?.companyId}`;
  } else {
    url = `${env}${API_ENDPOINT.Dashboard.topCompanies + '?location=' + (data?.location ? data?.location : '') + '&dateFrom=' + data?.dateFrom + '&dateTo=' + data?.dateTo}`;
  }
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};

export const companyTripStatsApi = async (data) => {
  const url = `${env}${API_ENDPOINT.Dashboard.companyTripStats + '/' + data?.companyId}`;
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};

export const companiesDataApi = async (data) => {
  const page = data?.page === 0 || data?.page ? data?.page + 1 : 1;
  const url = `${env}${API_ENDPOINT.Dashboard.companyData + '?location=' + (data?.location ? data?.location : '') + '&page=' + page + '&pageSize=' + data?.pageSize}`;
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};
